import Login from "../pages/Login/Login";
import NotFound from "../pages/NotFound/NotFound";
import Main from "../pages/Main/Main";
import ActivityLog from "../pages/ActivityLog/ActivityLog";
import Settings from "../pages/Settings/Settings";
import MemberKnowledgeBase from "../pages/MemberKnowledgeBase/MemberKnowledgeBase";
import UploadAudio from "../pages/AudioSummarizer/UploadAudio";
import Summarized from "../pages/AudioSummarizer/Summarized";
import DataDrivenChat from "../pages/DataDrivenChat/DataDrivenChat";
import ProtectedAdminRoute from './auth/ProtectedAdminRoute';
import ChatWithDisclaimer from "../components/ChatWithDisclaimer";
export const ROUTES = [
  {
    path: "/",
    element: <Login />,
    isNavBarDisplay: false,
    isSideBarDisplay: false,
  },
  {
    path: "/main",
    element: (
      <ProtectedAdminRoute>
        <Main />
      </ProtectedAdminRoute>
    ),
    isNavBarDisplay: true,
    isSideBarDisplay: false,
  },
  {
    path: "/chat",
    element: <ChatWithDisclaimer />, // ✅ wrapped with disclaimer logic
    isNavBarDisplay: true,
    isSideBarDisplay: true,
  },
  {
    path: "/activity-log",
    element: (
      <ProtectedAdminRoute>
        <ActivityLog />
      </ProtectedAdminRoute>
    ),
    isNavBarDisplay: true,
    isSideBarDisplay: false,
  },
  {
    path: "/settings",
    element: (
      <ProtectedAdminRoute>
        <Settings />
      </ProtectedAdminRoute>
    ),
    isNavBarDisplay: true,
    isSideBarDisplay: false,
  },
  {
    path: "/member-knowledge-base",
    element: (
      <ProtectedAdminRoute>
        <MemberKnowledgeBase />
      </ProtectedAdminRoute>
    ),
    isNavBarDisplay: true,
    isSideBarDisplay: false,
  },
  {
    path: "/upload-audio",
    element: (
      <ProtectedAdminRoute>
        <UploadAudio />
      </ProtectedAdminRoute>
    ),
    isNavBarDisplay: true,
    isSideBarDisplay: false,
  },
  {
    path: "/audio-summarized",
    element: (
      <ProtectedAdminRoute>
        <Summarized />
      </ProtectedAdminRoute>
    ),
    isNavBarDisplay: true,
    isSideBarDisplay: false,
  },
  {
    path: "/*",
    element: <NotFound />,
    isNavBarDisplay: false,
    isSideBarDisplay: false,
  },
];
